export enum PortfolioSource {
  PORTFOLIO_LOCALE = 'LOCALE',
  PORTFOLIO_CROSSCHAIN = 'PORTFOLIO_CROSSCHAIN',
}
